import * as React from "react"
import type { SVGProps } from "react"
const SvgMicrophone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 14.57a3 3 0 0 1-2.12-.87A3 3 0 0 1 9 11.57v-6q0-1.25.88-2.12A3 3 0 0 1 12 2.57q1.25 0 2.13.88.87.87.87 2.12v6q0 1.25-.87 2.13a3 3 0 0 1-2.13.87m-1 6V18.5a6.8 6.8 0 0 1-3.94-1.95 7 7 0 0 1-1.98-3.95 1 1 0 0 1 .22-.73q.28-.3.7-.3c.42 0 .52.1.71.29q.3.3.39.71a4.8 4.8 0 0 0 1.74 2.88A5 5 0 0 0 12 16.57q1.8 0 3.18-1.14a5 5 0 0 0 1.72-2.86q.1-.42.39-.71a1 1 0 0 1 .71-.29.9.9 0 0 1 .93 1.03 7 7 0 0 1-1.98 3.92A6.7 6.7 0 0 1 13 18.5v2.07q0 .42-.29.71a1 1 0 0 1-.71.29 1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71m1-8q.42 0 .71-.29a1 1 0 0 0 .29-.71v-6a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29 1 1 0 0 0-.71.29 1 1 0 0 0-.29.71v6q0 .42.29.71.29.3.71.29" />
  </svg>
)
export default SvgMicrophone
